import { Provider } from '@angular/core';

import { AuditRepositoryImpl } from '@app/data/repositories/audit/audit.repository';
import { AUDIT_REPOSITORY } from '@app/domain/repositories/audit/audit.repository.contract';

export const auditRepositoryProvider: Provider = {
  provide: AUDIT_REPOSITORY,
  useClass: AuditRepositoryImpl
};
